"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.report = void 0;
// this is exposed for testing purposes
// eslint-disable-next-line no-console,import/prefer-default-export
var report = exports.report = function report(message) {
  return console.warn(message);
};
//# sourceMappingURL=reporter.js.map